'use strict';

import jQuery from 'jquery';

var Drawer = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function init() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the hidden drawer content
      privateNS.$drawer = privateNS.$container.find('.drawer-content');

      // Create a reference to the collection of drawer labels
      privateNS.$drawerLabels = privateNS.$container.find('.drawer-label');

      // Attach event handlers
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Toggle the view state
     *
     * @param {Event} event Toggles the view state of the drawer
     */
    privateNS.toggleDrawer = function toggleDrawer(event) {

      // Prevent any default action of this event
      event.preventDefault();

      // Toggle the display state of the drawer content and the drawer labels
      privateNS.$drawer.slideToggle();
      privateNS.$drawerLabels.toggleClass('hide');
    };

    /**
     * Attach the event handlers for the header triggers
     */
    privateNS.attachHandlers = function attachHandlers() {

      // Add the triggers for all of the drawer buttons
      privateNS.$container.on(
        'click',
        '.drawer-trigger',
        privateNS.toggleDrawer
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Drawer